export function getRenderParams(className, sportId, headerPhrase, view, hasTopLeaguesOnly, shouldShowCoupononBottom) {
    return {
        className,
        sportId,
        headerPhrase,
        view,
        hasTopLeaguesOnly,
        shouldShowCoupononBottom
    };
}
//# sourceMappingURL=getRenderParams.js.map